// extracted by mini-css-extract-plugin
export default {"drawer-container":"Drawer_drawer-container__BIN7+","drawer-content":"Drawer_drawer-content__1I54p","left":"Drawer_left__PMQfO","right":"Drawer_right__cGfkm"};